import { createClient as createSupabaseClient } from '@supabase/supabase-js'
import { getSupabaseClientConfig } from '@/config/integrations/supabase'
import type { Database } from '@/lib/database.types'

let client: ReturnType<typeof createSupabaseClient<Database>> | null = null

/** Cliente Supabase browser — sessão em localStorage. */
export function createClient() {
  if (client) return client
  const { url, anonKey } = getSupabaseClientConfig()
  client = createSupabaseClient<Database>(url, anonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      storage: window.localStorage,
    },
  })
  return client
}
